import {Document} from "../model/document";
import {PricingPackageExplicitDocument} from "../model/platform/pricingPackageExplicitDocument";
import StringUtils from "./string-utils";

export default class PackageSelectionUtils {

  /**
   * Determines whether a document's explicit selections match a pricing package definition
   *
   * A match requires:
   * - The set of selected service short names to equal the explicitly bookable services
   * - The set of selected subclasses to equal the explicitly allowed subclasses
   *
   * @param document Document that should be checked for a match
   * @param explicitDocument Explicit document that should be matched against the document
   * @return True if the document matches the explicit document, otherwise false
   */
  static isExplicitDocumentSelectionMatch(document: Document, explicitDocument: PricingPackageExplicitDocument): boolean {
    const selectedServiceShortNames = (document.selectedServices || [])
      .map(service => service?.nameShort)
      .filter(Boolean);
    const explicitServiceShortNames = (explicitDocument.bookableServices || [])
      .map(service => service?.toString?.())
      .filter(Boolean);

    if (!StringUtils.areSameStringSets(selectedServiceShortNames, explicitServiceShortNames)) {
      return false;
    }

    const selectedSubClasses = (document.subInformations || [])
      .map(subInfo => subInfo?.nameShort || subInfo?.subClass?.className)
      .filter(Boolean);
    const explicitSubClasses = (explicitDocument.subClasses || [])
      .map(subClass => subClass?.toString?.())
      .filter(Boolean);

    return StringUtils.areSameStringSets(selectedSubClasses, explicitSubClasses);
  }
}
